import styled from 'styled-components';
import { Button } from '@upgrade/react-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledButton = styled(Button)`
  width: 100%;
  &:disabled {
    opacity: 1;
  }
`;
